import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import VueResource from 'vue-resource'
Vue.use(VueResource)
import VueClipboard from 'vue-clipboard2'
 
Vue.use(VueClipboard)



Vue.config.productionTip = false
Vue.http.options.emulateJSON = false
Vue.http.options.credentials = true

//引用filter
import filters from './filter'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

function isWeChat() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger'
}

Vue.http.interceptors.push((request, next) => {
    let token = localStorage.getItem('mall_token')
    if (token) {
        request.headers.set('Token', token)

    }
    if (request.method == "POST") {
        let body = request.body

     
    }
    next((response) => {
        let body = response.body
        if (body["err"]) {
            if (body.err == "notLogin") {
                localStorage.setItem("mall_token", "")
                let url = encodeURIComponent(window.location.href)
                let desk_url = `https://open.weixin.qq.com/connect/qrconnect?appid=wxddc5c0f4a9c9c368&redirect_uri=${url}&response_type=code&scope=snsapi_login&state=desktop#wechat_redirect`
                let mobile_url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05e8119ac9313dc0&redirect_uri=http%3A//wechat.diangezan.me/login/wechat_gate2&response_type=code&scope=snsapi_userinfo&state=${url}#wechat_redirect`
                let wechat = isWeChat()
                let gate_url = wechat ? mobile_url : desk_url
                window.location.href = gate_url
            } else if (body.err == "black") {
                window.location.href = "http://baidasdasdasdsdsdaddsu.com"

            } else {
                console.log("有其他的错误类型: ", body["err"])
            }

        } else {
            return response;
        }
    });
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
